<template>
  <div class="frisbuy-outfit-on-model">
    <div
      ref="tileWrapper"
      class="frisbuy-outfit-on-model__wrapper"
      v-touch:swipe="(direction: string) => changePostBySwipe(direction)"
    >
      <div
        v-if="titleMode !== 'hidden'"
        ref="tileTitle"
        class="frisbuy-outfit-on-model__title"
      >
        <template v-if="titleMode === 'default'"> Готовые комплекты </template>
        <template v-if="titleMode === 'postsCount'">
          <div class="frisbuy-outfit-on-model__title__sample">
            Дополните образ ({{ productsList.length }})
          </div>
        </template>
      </div>

      <div
        v-if="titleMode == 'default'"
        ref="tileSubtitle"
        class="frisbuy-outfit-on-model__subtitle"
      >
        Наводите на товар и переходите в карточку товара
      </div>

      <div
        class="frisbuy-outfit-on-model__kit"
        ref="tileKit"
        :style="{ height: fashionTileKitHeight }"
      >
        <div class="products-scoll-block" ref="swiper">
          <div class="frisbuy-outfit-on-model__navigation">
            <button class="frisbuy-navigation-button frisbuy-prev-navigation-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" transform="matrix(0 -1 1 0 0 24)" fill="white" fill-opacity="0.8"/>
                <path d="M9.5 18L14.5 12L9.5 6" stroke="#303635" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button class="frisbuy-navigation-button frisbuy-next-navigation-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" transform="matrix(0 -1 1 0 0 24)" fill="white" fill-opacity="0.8"/>
                <path d="M9.5 18L14.5 12L9.5 6" stroke="#303635" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div class="frisbuy-outfit-on-model__kit-products swiper-wrapper">
            <ProductItem
              v-for="product in productsList"
              :key="product.id"
              :product="product"
              class="swiper-slide"
              :linkTarget="
                Boolean(popupSettings.targetBlankLink) ? '_blank' : '_self'
              "
              :isLiked="
                Boolean(
                  favoriteVendorList.find((el) =>
                    isEqual(el, {
                      article: product.sku?.vendorCode,
                      offerId: product.sku?.offerId,
                      groupId: product.sku?.groupId,
                    })
                  )
                )
              "
              @clickProduct="(product) => sendProductAnalytics(product)"
              @like="() => addProductToFavoriteList([product])"
            />
          </div>
        </div>

        <!-- <ButtonArrow
          v-show="hasNextPost"
          @click="() => makeEventToChangePost(1)"
          :direction="'right'"
        /> -->
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/gallery/mixins.scss";
@import "../mixins.scss";

$mainPhotoSize: 39.9844%;
$spaceBetweenPhotoAndProducts: 5.2%;

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.frisbuy-outfit-on-model {
  max-height: 100%;
  // height: 94dvh;

  .frisbuy-outfit-on-model__wrapper {
    width: 100%;
    height: 100%;
    overflow: visible;
  }

  .frisbuy-outfit-on-model__title {
    font-family: inherit;
    font-size: 11px;
    line-height: 13px;
    color: rgba(0, 11, 11, 1);

    .frisbuy-outfit-on-model__title__sample {
      text-transform: uppercase;
    }
  }

  .frisbuy-outfit-on-model__subtitle {
    font-family: inherit;
    font-size: 16px;
    color: #2e353b;

    margin-top: 18px;
  }

  .frisbuy-outfit-on-model__kit {
    container-type: inline-size;

    grid-template-columns: none;
    display: grid;
    width: 100%;
    height: 100%;
    gap: 0 $spaceBetweenPhotoAndProducts;

    padding-top: 13px;

    .frisbuy-outfit-on-model__main-item {
      display: flex;
      position: relative;
      width: 100%;
      max-height: 100%;

      background-color: #e6e6e6;

      img {
        position: absolute;
        inset: 0;

        object-fit: cover;
        width: 100%;
        height: 100%;
      }

      .frisbuy-like-button {
        position: absolute;
        inset: 12px 23px auto auto;
        width: 30px;
      }
    }

    .products-scoll-block {
      display: block;
      position: relative;
      width: 100%;
      max-height: 100%;
      overflow: hidden;

      .frisbuy-outfit-on-model__kit-products {
        display: flex;
        // NOTE: on some displays last pixel can be hidden by overflow
        width: calc(100% - 1px);

        .frisbuy-outfit-product-item {
          width: 123px;
        }
      }
    }

    .frisbuy-button-arrow {
      width: 11px;
      height: 22px;

      z-index: 3;

      &.--left {
        left: calc(0cqmin - 20px);
      }

      &.--right {
        right: calc(0cqmin - 20px);
      }
    }
  }
}

// media quieries
.frisbuy-outfit-on-model {
  container-type: inline-size;
  container-name: fashionTile;

  @media (max-width: $size-s) {
    & {
      height: fit-content;
      max-height: unset;
    }
  }

  @container (max-width: #{$size-xs}) {
    .frisbuy-outfit-on-model__wrapper {
      height: fit-content;
      overflow-x: hidden;
      overflow-y: visible;

      .frisbuy-outfit-on-model__kit {
        display: block;
        position: relative;
        flex-direction: row;
        flex-wrap: wrap;
        min-height: unset;

        .frisbuy-outfit-on-model__main-item {
          width: 100%;
          aspect-ratio: 340 / 454;

          .frisbuy-like-button {
            inset: 15px 15px auto auto;
          }
        }

        .products-scoll-block {
          // margin-top: 40px;
          overflow: visible;
        }

        .frisbuy-button-arrow {
          width: 6px;
          height: 12px;

          stroke-width: 2px;

          top: calc(70cqmin + 45px);

          &.--left {
            left: 2.2%;
          }

          &.--right {
            right: 2.2%;
          }
        }
      }
    }
  }
}

.frisbuy-outfit-on-model .frisbuy-outfit-on-model__kit .products-scoll-block {
  container-type: inline-size;

  @container (max-width: 654px) {
    .frisbuy-outfit-on-model__kit-products {
      grid-template-columns: repeat(auto-fit, minmax(144px, auto));
    }
  }

  @container (max-width: 470px) {
    .frisbuy-outfit-on-model__kit-products {
      grid-template-columns: repeat(auto-fit, minmax(138px, auto));
    }
  }

  @container (max-width: 450px) {
    .frisbuy-outfit-on-model__kit-products {
      grid-template-columns: repeat(auto-fit, minmax(135px, auto));
    }
  }
}
</style>

<style lang="scss">
@import "../mixins.scss";

.frisbuy-outfit-on-model {
  @container fashionTile (max-width: #{$size-xs}) {
    .frisbuy-outfit-on-model__kit {
      .products-scoll-block {
        .frisbuy-outfit-on-model__kit-products {
          .frisbuy-outfit-product-item {
            .frisbuy-outfit-product-item__image {
              .frisbuy-like-button {
                inset: 7px auto auto 8px;
                width: 21px;
              }
            }
          }
        }
      }
    }
  }
}

</style>

<style lang="scss">
@import "../mixins.scss";
// swiper styles

.frisbuy-outfit-on-model__navigation {
  position: absolute;
  width: 100%;
  height: 0;
  top: 90px;
  transform: translateY(-50%);

  display: flex;
  align-items: center;
  justify-content: space-between;

  z-index: 2;

  .frisbuy-prev-navigation-button {
    transform: rotate(180deg);

    &.frisbuy-navigation-button {
      &:hover {
        transform: rotate(180deg);
      }
    }
  }

  @media (max-width: $size-s) {
    & {
      display: none;
    }
  }
}
</style>

<script lang="ts">
import { PropType, defineComponent } from "vue";
// @ts-ignore: lodash types's errors on build
import _ from "lodash";
import ProductItem from "./ProductItem.vue";
// import ButtonArrow from "./ButtonArrow.vue";
// import LikeButton from "./LikeButton.vue";
import { IFrisbuyWidgetPost, IPostLinkInList } from "@/gallery/interfaces";
import { TProductCode } from "../interfaces.js";
import { getStock } from "@/common/mixins/analytics";
import Swiper, { Scrollbar, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";

interface IFashionTile {
  fashionTileKitHeight: string;
  favoriteVendorList: Array<TProductCode>;
}

export default defineComponent({
  inject: ["isTablet"],

  components: {
    ProductItem,
    // LikeButton,
    // ButtonArrow
  },

  emits: {
    changePostRequest: (direction: number) => {
      return direction;
    },
  },

  props: {
    fashion: {
      type: Object as PropType<IFrisbuyWidgetPost>,
      required: true,
    },

    titleMode: {
      type: String as PropType<"default" | "postsCount" | "hidden">,
      required: false,
      default: "default",
    },

    // NOTE: this settings only for analytics in mixins
    // TODO: remove this after removing mixins
    settings: {
      type: Object,
      required: true,
    },

    popupSettings: {
      type: Object,
      required: true,
    },

    hasPrevPost: {
      type: Boolean,
      required: false,
      default: true,
    },

    hasNextPost: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data(): IFashionTile {
    return {
      fashionTileKitHeight: "100%",
      favoriteVendorList: [],
    };
  },

  created() {
    this.initFrisbuyFavoriteList();
  },

  mounted() {
    this.calculateFashionTileKitHeight();
    window.addEventListener("resize", this.calculateFashionTileKitHeight);

    this.$nextTick(() => {
      new Swiper(this.$refs.swiper, {
        modules: [Navigation, Scrollbar],

        speed: 500,
        loop: false,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        slidesOffsetAfter: 0,
        spaceBetween: 6,
        simulateTouch: true,
        freeMode: true,

        navigation: {
          enabled: true,
          nextEl: ".frisbuy-next-navigation-button",
          prevEl: ".frisbuy-prev-navigation-button",
          disabledClass: "frisbuy-navigation-button-disabled",
        },

        scrollbar: {
          draggable: true,
        },
      });
    });
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.calculateFashionTileKitHeight);
  },

  methods: {
    // TODO: refactor this shit
    isEqual(value: any, other: any) {
      return _.isEqual(value, other);
    },

    initFrisbuyFavoriteList() {
      if (window.frisbuyFavoriteList) {
        this.favoriteVendorList = window.frisbuyFavoriteList;
      }

      console.log("window.frisbuyFavoriteList", window.frisbuyFavoriteList);

      // TODO: refactor "defineProperty" logic. Too hard to understand
      let frisbuyFavoriteListWindowValue: Array<TProductCode> = [];

      Object.defineProperty(window, "frisbuyFavoriteList", {
        configurable: true,
        set: function (value) {
          if (!value) return;

          frisbuyFavoriteListWindowValue = value;

          console.log("defineProperties", value);
          this.favoriteVendorList = value || [];
        },

        get: function () {
          return frisbuyFavoriteListWindowValue;
        },
      });

      window.frisbuyFavoriteList = this.favoriteVendorList || [];
    },

    makeEventForClient(eventName: string, data: any) {
      document.dispatchEvent(new CustomEvent(eventName, data));
    },

    changePostBySwipe(direction: string) {
      if (direction === "left") {
        this.makeEventToChangePost(1);
      }

      if (direction === "right") {
        this.makeEventToChangePost(-1);
      }
    },

    makeEventToChangePost(direction: number) {
      this.$emit("changePostRequest", direction);
    },

    addProductToFavoriteList(
      products: Array<IPostLinkInList>,
      isRemoveExisting = true
    ) {
      const productCodes: Array<TProductCode> = products.map((product) => {
        return {
          article: product.sku?.vendorCode,
          offerId: product.sku?.offerId,
          groupId: product.sku?.groupId,
        };
      });

      if (!productCodes || !productCodes.length) {
        return;
      }

      let isAddingToFavorite = false;

      let listOfProducts: Array<TProductCode> = [];
      let isAllProductsSelected = false;
      let dubledProducts: Array<TProductCode> = [];

      listOfProducts.push(...productCodes);

      // NOTE: check on adding FullFavoriteLook
      if (productCodes.length > 1) {
        isAllProductsSelected = true;

        dubledProducts = listOfProducts.filter((propductFromList) => {
          const isIncludes = this.favoriteVendorList.find((el) => {
            return this.isEqual(el, propductFromList);
          });

          if (isIncludes) {
            return propductFromList;
          } else {
            isAllProductsSelected = false;
          }
        });
      }

      /*
        При добавлении всего образа клиент попросил отфильтровать уже выбранные, чтобы не удалять их со своей стороны
      */
      let listOfProductsWithoutDoublers = listOfProducts;

      console.log(listOfProducts.length, this.favoriteVendorList.length);
      if (listOfProducts.length !== this.favoriteVendorList.length) {
        console.log("filter");
        listOfProductsWithoutDoublers = listOfProducts.filter((product) => {
          const isIncludes = dubledProducts.find((el) => {
            return this.isEqual(el, product);
          });

          if (!isIncludes) {
            return product;
          }
        });
      }

      if (isAllProductsSelected) {
        this.removeCompilationOfCodesSafety(this.compilationOfAllProductsCodes);
      }

      if (!isAllProductsSelected) {
        listOfProducts.forEach((product) => {
          const existingElementIndex = this.favoriteVendorList.findIndex(
            (el) => {
              return this.isEqual(el, product);
            }
          );

          if (isRemoveExisting && existingElementIndex >= 0) {
            // Removing product from favorite
            this.favoriteVendorList.splice(existingElementIndex, 1);
          } else if (existingElementIndex === -1) {
            // Adding product to favorite
            this.favoriteVendorList.push(product);
            isAddingToFavorite = true;
          }
        });
      }

      if (isAddingToFavorite) {
        console.log(
          "%cfrisbuy:favorite-add detail",
          "background-color: #33ab55",
          listOfProductsWithoutDoublers
        );
        this.makeEventForClient("frisbuy:favorite-add", {
          detail: listOfProductsWithoutDoublers,
        });

        // [START] analytics
        const productsForAnalytics = products.filter((product) => {
          const originalProduct = listOfProductsWithoutDoublers.find(
            (productIds) => {
              const idsFromOriginalProduct: TProductCode = {
                article: product.sku?.vendorCode,
                offerId: product.sku?.offerId,
                groupId: product.sku?.groupId,
              };

              if (this.isEqual(idsFromOriginalProduct, productIds)) {
                return true;
              } else {
                return false;
              }
            }
          );

          return originalProduct;
        });

        // TODO: fix this after removing mixins
        // @ts-ignore: this analytics in fucking mixins
        this.sendAnaliticEvent("AddToFavorite", {
          provPostId:
            this.fashion.instagramPost?.frisbuyId ??
            this.fashion.providerPost.frisbuyId,
          fbProduct: this.fashion.frisbuyPost.id,
          igCode: this.fashion.instagramPost.shortcode,
          stock: getStock(
            this.postList,
            this.settings.embedId,
            this.settings.skuId
          ),

          items: productsForAnalytics,
        });
        // [END] analytics
      } else {
        console.log(
          "%cfrisbuy:favorite-remove detail",
          "background-color: #df3355",
          listOfProductsWithoutDoublers
        );
        this.makeEventForClient("frisbuy:favorite-remove", {
          detail: listOfProductsWithoutDoublers,
        });

        // [START] analytics
        // TODO: fix this after removing mixins
        // @ts-ignore: this analytics in fucking mixins
        // this.sendAnaliticEvent("RemoveFromFavorite", {
        //   provPostId:
        //     this.fashion.instagramPost?.frisbuyId ??
        //     this.fashion.providerPost.frisbuyId,
        //   fbProduct: this.fashion.frisbuyPost.id,
        //   igCode: this.fashion.instagramPost.shortcode,
        //   stock: getStock(
        //     this.postList,
        //     this.settings.embedId,
        //     this.settings.skuId
        //   ),

        //   items: productsForAnalytics,
        // });
        // [END] analytics
      }
    },

    removeCompilationOfCodesSafety(codesForRemoving: Array<TProductCode>) {
      const clearedFavoriteVendorList: Array<TProductCode> =
        this.favoriteVendorList.filter((favoriteCode) => {
          let isEqualCode = false;
          codesForRemoving.forEach((codeForRemoving) => {
            if (this.isEqual(codeForRemoving, favoriteCode)) {
              isEqualCode = true;
            }
          });

          if (!isEqualCode) {
            return favoriteCode;
          }
        });

      /* 
        NOTE:
          "this.favoriteVendorList = [];" or
          "this.favoriteVendorList = clearedFavoriteVendorList;" doesn't work
        In initFrisbuyFavoriteList defineProperties cannot see array's redefining
      */
      this.favoriteVendorList.splice(0, this.favoriteVendorList.length);
      this.favoriteVendorList.push(...clearedFavoriteVendorList);
    },

    sendProductAnalytics(product: IPostLinkInList) {
      // TODO: fix this after removing mixins
      // @ts-ignore: this analytics in fucking mixins
      this.sendAnaliticEvent("ClickLink", {
        provPostId:
          this.fashion.instagramPost?.frisbuyId ??
          this.fashion.providerPost.frisbuyId,
        fbProduct: this.fashion.frisbuyPost.id,
        igCode: this.fashion.instagramPost.shortcode,
        link: product.link,
        linklabel: product.title,
        offer: product.sku?.offerId,
      });
    },

    async calculateFashionTileKitHeight() {
      if (!this.$refs.tileWrapper) {
        return;
      }

      this.fashionTileKitHeight = "100%";
      await this.$nextTick();

      const tileHeightPx = this.$refs.tileWrapper.offsetHeight;

      const tileTitleHeightPx = Math.max(
        this.$refs.tileTitle?.offsetHeight,
        this.$refs.tileTitle?.clientHeight
      );
      const tileSubtitleHeightPx = Math.max(
        this.$refs.tileSubtitle?.offsetHeihgt,
        this.$refs.tileSubtitle?.clientHeight
      );

      let tileKitHeightPx = this.$refs.tileKit.offsetHeight;

      if (tileTitleHeightPx) {
        tileKitHeightPx -= tileTitleHeightPx;
      }

      if (tileSubtitleHeightPx) {
        tileKitHeightPx -= tileSubtitleHeightPx;
      }

      this.fashionTileKitHeight = `${(tileKitHeightPx / tileHeightPx) * 100}%`;
    },
  },

  computed: {
    // NOTE: this settings only for analytics in mixins. Parameter "stock"
    // TODO: remove this after removing mixins
    postList(): Array<IFrisbuyWidgetPost> {
      const pseudoPostList = [this.fashion];
      return pseudoPostList;
    },

    productsList(): IPostLinkInList[] {
      return this.fashion.media[0].linkList;
    },

    isFullFavoriteLook(): boolean {
      const isFavorite =
        this.productsList.length > 0 &&
        !this.productsList.find((product) => {
          return !this.favoriteVendorList.find((favorit) => {
            const productCode: TProductCode = {
              article: product.sku?.vendorCode,
              offerId: product.sku?.offerId,
              groupId: product.sku?.groupId,
            };

            return this.isEqual(favorit, productCode);
          });
        });

      return isFavorite;
    },

    compilationOfAllProductsCodes(): Array<TProductCode> {
      const articlesList: Array<TProductCode> = this.productsList.map(
        (product) => {
          return {
            article: product.sku?.vendorCode,
            offerId: product.sku?.offerId,
            groupId: product.sku?.groupId,
          };
        }
      );

      console.log("articlesList", articlesList);

      return articlesList;
    },
  },
});
</script>
